module.exports = __webpack_public_path__ + "static/media/29EUNOG17.36be7e90.jpg";